import { render, staticRenderFns } from "./CustomerGrowerEdit.vue?vue&type=template&id=8ac585d6"
import script from "./CustomerGrowerEdit.vue?vue&type=script&lang=js"
export * from "./CustomerGrowerEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports